import React from 'react'
import PropTypes from 'prop-types'

import { Avatar } from '@material-ui/core'

const ImageAvatars = (props) => {
  const { name, src, className } = props
  return <Avatar alt={name} src={src} className={className} {...props} />
}
export default ImageAvatars

ImageAvatars.propTypes = {
  name: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
}
